export const TanstackQueryConfiguration = {
	StaleTime: 1000 * 60 * 60,
	RefetchInterval: 1000 * 60 * 60,
};

export const Validations = {
	TransferTargetMaxLength: 50,
	// What a search may cost, which is not what a transfer target may be: a directory address can run well
	// past the length the box accepts as a destination, and refusing to look for it leaves the agent with no
	// way to reach a contact who is in the directory. Long enough for any address, short enough that a pasted
	// signature is refused before it turns into a wildcard clause per word per field.
	TransferSearchMaxLength: 200,
	ContactNoteMaxLength: 512,
	InteractionNoteMaxLength: 4000,
	EmailSubjectMaxLength: 255
};

export const RegEx = {
	Sip: /^(sip:)?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
	PhoneNumber: /^\+?([0-9]+)$/,
	Email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9_](?:[a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?(?:\.[a-zA-Z0-9_](?:[a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_])?)*$/,
	DTMF: /^([0-9*#]+)$/,
	HtmlTags: /<[^>]+>|&nbsp;/g,
	TimeSpan: /^(23|([0-5][0-9])):(59|([0-5][0-9])):(59|([0-5][0-9]))$/,
	RouteCallDestination:
		/^(?:([^.][^@ ]+)@((?:([a-z0-9]+[.])|([a-z0-9]+[.][a-z]+[.]))[a-z]+)|((?:([+][0-9]+)|([0-9]+))))$/i,
	Guid: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
};

export const Colors = {
	NeutralBackground1HoverStatic: "#f5f5f5",
	NeutralStroke1Static: "#d1d1d1",
	NeutralForeground2Static: "#424242",
	PaletteRedBorder1Static: "#f1bbbc",
	PaletteRedBackground1Static: "#fdf6f6",
	NeutralBackground6: "#e6e6e6",
	NeutralBackground5: "#ebebeb",
	NeutralForeground3: "#616161",
	ButtonGreenBackground: "#6BB700",
	ButtonGreenBackgroundHover: "#60a400",
};

export const HtmlIds = {
	EditorFluentProvider: "editor-fluent-provider",
};

export const WindowWidthThresholds = {
	Large: 1440,
};

export const ContainerSizeDefaults = {
	InteractionPanelWidth: 296,
	InteractionPanelIntermediateWidth: 464,
	InteractionPanelMaxWidth: 564,
	ToggledViewPanelDefaultWidth: 384,
	ToggledViewPanelMinWidth: 360,
	ToggledViewPanelMaxWidth: 464,
	WorkspacePanelWidth: 742,
	AllWaitingInteractionsMinWidth: 416,
	AllWaitingInteractionsMaxWidth: 900,
	PanelsMaxWidthOnTablet: 364
};

export const WorkspaceSizeThresholds = {
	Medium: 756,
	Small: 584,
};

export const formValidationRequiredKey = "Common.Validations.RequiredField";

export const feedbackMaxDescriptionLength = 4096;

export const feedbackMaxFieldsLength = 50;

export const feedbackScreenshotSizeLimitMB = 1;

export const feedbackScreenshotSizeLimit =
	feedbackScreenshotSizeLimitMB * 1024 * 1024;

export const WebchatDefaultCustomerName = "Unknown_customer";

export const WarmTransfer = "WarmTransfer";

export const SUBJECT_CHANGE_INFO_MESSAGE_KEY = "subjectChangeInfo";

export const TotalAttachmentSizeLimitMB = 10;
export const TotalAttachmentSizeLimit =
		TotalAttachmentSizeLimitMB * 1024 * 1024; // 10MB
export const AttachmentSizeLimitMB = 3;
export const AttachmentSizeLimit = AttachmentSizeLimitMB * 1024 * 1024; // 3MB
